/* //* Package imports */
import {useState} from 'react'
import { Modal, Button } from "react-bootstrap";
import { Link } from 'react-router-dom';

/* //* Component imports */
import NewLeadForm from './../booking/newLeadForm'
import ExportLeads from './ExportLeads';

const FormModal = (props) => {
  return (
    <Modal
    {...props}
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
    <Modal.Header closeButton>
      <Modal.Title id="contained-modal-title-vcenter">
        Create New Lead
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <NewLeadForm />
    </Modal.Body>
  </Modal>
  );
}

const CreateForm = () => {
    const [modalShow, setModalShow] = useState(false);

    return (
    <>
      <Button variant="primary" style={{background:"#045e92"}} onClick={() => setModalShow(true)}>
        Create New Lead
      </Button>
      <Link to='/upload'>
        <Button variant="primary" style={{background:"#045e92"}} >
          Upload leads
        </Button>
      </Link>
      <ExportLeads/>

      <FormModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      </>
    );
  }

export default CreateForm;
